<template>
  <tr class="rf-skeleton-row h-20">
    <td><RfBaseSkeleton width="140" /></td>
    <td><RfBaseSkeleton width="80" /></td>
    <td><RfBaseSkeleton width="150" dynamic range="30" /></td>
    <td><RfBaseSkeleton width="60" /></td>
    <td>
      <div class="flex flex-col gap-2">
        <RfBaseSkeleton width="120" />
        <RfBaseSkeleton width="60" />
      </div>
    </td>
    <td><RfBaseSkeleton width="60" /></td>
    <td>
      <div class="flex flex-col gap-2">
        <RfBaseSkeleton width="80" />
        <RfBaseSkeleton width="120" />
      </div>
    </td>
    <td><RfBaseSkeleton width="100" /></td>
    <td><RfBaseSkeleton width="50" /></td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";
</script>
